import React from "react";
import { cls } from "app/utils";
import ModalWrapper from "app/components/modals/ModalWrapper";
import Support from "app/components/paywalls/Support";
import { usePaywall } from "../usePaywall";
import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";

interface BasePaywallProps {
  show: boolean;
  onClose: () => void;
  title: string;
  image: string;
  returnUrl: string;
  upperContent?: React.ReactNode;
  featureName?: string;
  alwaysShowTrial?: boolean;
  imageClassname?: string;
}

export default function BasePaywall({
  show,
  onClose,
  title,
  image,
  returnUrl,
  upperContent,
  featureName = "Space Limit",
  alwaysShowTrial = false,
  imageClassname,
}: BasePaywallProps) {
  const { t } = useTranslation();
  const { canStartTrial, handleUpgrade, handleStartTrial, handleClose } =
    usePaywall({ returnUrl, onClose });

  return (
    <ModalWrapper isOpen={show} onRequestClose={handleClose} title={t(title)}>
      <div className={cls(styles.spacesLimitModal)}>
        <div className={styles.upper}>
          <div className={styles.image}>
            <img src={image} alt="Paywall Icon" className={imageClassname} />
          </div>
          {upperContent}
        </div>

        <div className={styles.lower_section}>
          <div className={styles.section}>
            <h3>{t("Why Upgrade?")}</h3>
            <p className={styles.description}>
              {t(
                "Transform your coaching with unlimited Spaces, media posting, Library storage, Lists, and Templates.",
              )}
            </p>
            <button className="btn btn-primary" onClick={handleUpgrade}>
              {t("Upgrade Now")}
            </button>
          </div>

          {(canStartTrial || alwaysShowTrial) && (
            <div className={styles.section}>
              <h3 className={styles.highlightGreen}>{t("Try It Out!")}</h3>
              <p className={styles.description}>
                {t(
                  "Check out all the features CoachNow PRO has to offer, with a free 7-day trial.",
                )}
              </p>
              <button className="btn btn-success" onClick={handleStartTrial}>
                {t("Start Trial")}
              </button>
            </div>
          )}

          <div className={styles.section}>
            <Support className={styles.lower} feature={t(featureName)} />
          </div>
        </div>
      </div>
    </ModalWrapper>
  );
}
